<template>
  <div id="reco-page">
    <Reco />
  </div>
</template>

<script>
import Reco from '../components/Reco.vue'

export default {
  name: 'RecoPage',
  components: {
    Reco
  }
}
</script>

<style lang="css">

</style>



// WEBPACK FOOTER //
// src/pages/Reco.vue